
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/faq",
      function () {
        return require("private-next-pages/resources/faq.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/faq"])
      });
    }
  